import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router";
import { Form } from "antd";
import moment from "moment";
import { IOfferingGroupsContext } from "../../context/OfferingGroupsContext/types";
import { OfferingGroupsContext } from "../../context/OfferingGroupsContext/OfferingGroupsContext";
import { useAppDispatch, useAppSelector } from "../../../..";
import { OfferingGroupList } from "../OfferingGroupsList/OfferingGroupsList";
import { IOfferingGroupsSearch } from "../../types/IOfferingGroupsSearch";
import { toHttpFormatStartOfDay } from "../../../../lib/utils";
import { useDispatchWithCheck } from "../../../../lib/hooks/useDispatchWithCheck";
import {
  fetchOfferingGroupsEntityObjectTypeDic,
  fetchOfferingGroupsTypesDic,
  searchOfferingGroups,
} from "../../store/slice/offeringGroupsSlice";
import OfferingGroupView from "../OfferingGroupView/OfferingGroupView";
import OfferingGroupCreate from "../OfferingGroupCreate/OfferingGroupCreate";
import OfferingGroupAddOffer from "../OfferingGroupAddOffer/OfferingGroupAddOffer";
import {
  fetchPoliciesActionsDic,
  fetchPoliciesStatusDic,
  fetchPoliciesTypesDic,
} from "../../store/slice/policiesSlice";
import {
  fetchPaymentType,
  fetchProducts,
  fetchTariffModelTypes,
} from "../../../../store/slices/rtkDictionaries";
import { fetchServiceTypeList } from "../../../../store/slices/offering/offering";
import { fetchOfferingStatuses } from "../../../../store/slices/dicts";
import "./OfferingGroupsContainer.less";

export const OfferingGroupsContainer = () => {
  const dispatch = useAppDispatch();

  const { productsLoading, tariffModelTypesLoading, paymentTypeLoading } = useAppSelector(
    (state) => state.rtkDictionaries
  );
  const { offeringStatusesLoading } = useAppSelector((state) => state.dicts);
  const { serviceTypeListLoading } = useAppSelector((state) => state.offering);
  const {
    offeringGroupsTypesDicLoading,
    offeringGroupsEntityObjectTypeDicLoading,
  } = useAppSelector((state) => state.offeringGroups);
  const {
    policiesTypesDicLoading,
    policiesStatusDicLoading,
    policiesActionsDicLoading,
  } = useAppSelector((state) => state.policies);

  const { dispatchWithCheck } = useDispatchWithCheck();

  // Загрузка справочников
  useEffect(() => {
    dispatchWithCheck(fetchOfferingGroupsTypesDic(), offeringGroupsTypesDicLoading);
    dispatchWithCheck(
      fetchOfferingGroupsEntityObjectTypeDic(),
      offeringGroupsEntityObjectTypeDicLoading
    );
    dispatchWithCheck(fetchPoliciesTypesDic(), policiesTypesDicLoading);
    dispatchWithCheck(fetchPoliciesStatusDic(), policiesStatusDicLoading);
    dispatchWithCheck(fetchPoliciesActionsDic(), policiesActionsDicLoading);
    dispatchWithCheck(fetchProducts(), productsLoading);
    dispatchWithCheck(
      fetchServiceTypeList({
        onDate: toHttpFormatStartOfDay(moment()),
        includeFutureDates: true,
        includePastDates: false,
      }),
      serviceTypeListLoading
    );
    dispatchWithCheck(fetchTariffModelTypes(), tariffModelTypesLoading);
    dispatchWithCheck(fetchOfferingStatuses(), offeringStatusesLoading);
    dispatchWithCheck(fetchPaymentType(), paymentTypeLoading);
  }, []);

  const [isSearchOpen, setIsSearchOpen] = useState(true);
  const toggleSearchOpen = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const [offeringGroupsListSearchForm] = Form.useForm<IOfferingGroupsSearch>();

  const handleOfferingGroupsListSearch = (params?: { page?: number; size?: number }) => {
    const page = params?.page || 0;
    const size = params?.size || 7;
    const values: IOfferingGroupsSearch = offeringGroupsListSearchForm.getFieldsValue();
    if (values.memberObjectName) {
      values.memberTypeAlias = offeringGroupsListSearchForm.getFieldValue("memberTypeAlias");
      values.memberObjectId = offeringGroupsListSearchForm.getFieldValue("memberObjectId");
      delete values.memberObjectName;
    }
    const onDate = toHttpFormatStartOfDay(values.onDate);
    dispatch(searchOfferingGroups({ ...values, onDate, page, size }));
  };

  const contextValue: IOfferingGroupsContext = {
    isSearchOpen,
    toggleSearchOpen,
    handleOfferingGroupsListSearch,
    offeringGroupsListSearchForm,
  };

  return (
    <OfferingGroupsContext.Provider value={contextValue}>
      <div className="container_height inner-row offering-groups-container">
        <Switch>
          <Route path="/offering-groups" exact>
            <OfferingGroupList />
          </Route>
          <Route exact path="/offering-groups/create">
            <OfferingGroupCreate />
          </Route>
          <Route exact path="/offering-groups/add-offer">
            <OfferingGroupAddOffer />
          </Route>
          <Route path="/offering-groups/create/:offeringGroupId">
            <OfferingGroupCreate />
          </Route>
          <Route path="/offering-groups/:offeringGroupId">
            <OfferingGroupView />
          </Route>
        </Switch>
      </div>
    </OfferingGroupsContext.Provider>
  );
};
